import styled from 'styled-components';
import { Text } from '../../../design-system';
import { COLORS } from '../../styles/variables';
import { device } from '../../styles/devices';
import { AlphaTheme } from '../../../design-system/ThemeProvider/alphaTheme';

type TextCTAType = {
  color?: string;
  size?: 'small' | 'medium';
  isBold?: boolean;
  noUnderline?: boolean;
};

type FlexContainerType = {
  direction?: string;
  justifyContent?: string;
  gap?: number;
};

export const CopyOne = styled.p<{ color?: string; isBold?: boolean }>`
  color: ${({ color, theme }: { color?: string; theme: Partial<AlphaTheme> }) =>
    color ? color : (theme.foregroundNeutral100 ?? COLORS.grey80)};
  font-size: 16px;
  letter-spacing: 0.003px;
  line-height: 24px;
  font-family: 'Audi Type';
  font-weight: ${(props) => (props.isBold ? '700' : '400')};
`;

export const CopyTwo = styled.p<{ color?: string }>`
  color: ${({ color, theme }: { color?: string; theme: Partial<AlphaTheme> }) =>
    color ? color : (theme.foregroundNeutral100 ?? COLORS.grey80)};
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.002px;
  font-family: 'Audi Type';
`;

export const HeadlineOrderTwo = styled.h2<{ isBold?: boolean }>`
  margin: 0;
  font-family: 'Audi Type';
  letter-spacing: 0.002px;
  font-size: 24px;
  line-height: 36px;
  font-weight: ${(props) => (props.isBold ? '700' : '400')};
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
    theme.foregroundNeutral100 ?? COLORS.grey80};
  @media ${device.laptop} {
    font-size: 28px;
    line-height: 44px;
  }
  @media ${device.laptopL} {
    font-size: 32px;
    line-height: 48px;
  }
  @media ${device.desktop} {
    font-size: 36px;
    line-height: 52px;
  }
`;

export const TagLabel = styled.div`
  font-family: 'Audi Type';
  padding: 4px 12px;
  font-size: 12px;
  line-height: 20px;
  background-color: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
    theme.sidebarTablet ?? COLORS.grey5};
  display: flex;
  align-items: center;
  gap: 8px;
  width: max-content;
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
    theme.foregroundNeutral100 ?? COLORS.grey80};
  border-radius: ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.borderRadiusSm ?? '0'};
`;

export const TextCTA = styled.div<TextCTAType>`
  cursor: pointer;
  font-family: 'Audi Type';
  border: none;
  background-color: transparent;
  font-size: ${({ size }) => (size === 'medium' ? '16px' : '12px')};
  line-height: ${({ size }) => (size === 'medium' ? '24px' : '20px')};
  color: ${({ color, theme }: { color?: string; theme: Partial<AlphaTheme> }) =>
    color ?? theme.foregroundNeutral100 ?? COLORS.black};
  border-bottom: ${({
    noUnderline,
    color,
    theme,
  }: {
    noUnderline?: boolean;
    color?: string;
    theme: Partial<AlphaTheme>;
  }) =>
    noUnderline ? 'none' : `1px solid ${color ?? theme.foregroundNeutral100 ?? COLORS.black}`};
  padding: 0;
  font-weight: ${({ isBold }) => (isBold ? '700' : '400')};
  padding-bottom: 2px;
`;

export const StyledText = styled(Text)<{ color?: string }>`
  color: ${(props) => props.color && props.color};
`;

export const TextAlign = styled.div<{ align?: 'start' | 'end' | 'center' }>`
  text-align: ${(props) => props.align && props.align};
`;

export const FlexContainer = styled.div<FlexContainerType>`
  display: flex;
  flex-direction: ${({ direction }) => direction ?? 'row'};
  justify-content: ${({ justifyContent }) => justifyContent ?? ''};
`;
